import React, { useState, useEffect } from 'react';
import { theme } from '../../../theme';
import { styles } from './adminStyles';
import api from '../../../services/api';
import ReportsModal from '../../../components/ReportsModal';

// Reports tab: card grid is now data-driven from the backend report registry
// (GET /admin/reports) instead of a hardcoded list — a new report registered
// in backend/services/reportRegistry.js shows up here with no frontend change.
const AdminReports = ({ events }) => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openReportKey, setOpenReportKey] = useState(null);

  useEffect(() => {
    api.get('/admin/reports')
      .then(res => setReports(res.data))
      .catch(() => setReports([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={{...styles.card, minHeight: '200px', marginBottom: 0}}>
        <h2 style={{marginTop:0, color: theme.colors.primary}}>Reports</h2>
        {loading ? <p style={styles.textMuted}>Loading available reports...</p> : (
            <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(250px, 1fr))', gap:'20px'}}>
                {reports.map(r => (
                    <div key={r.key} style={{padding:'20px', border:'1px solid #ddd', borderRadius:'8px', textAlign:'center', backgroundColor: '#FFFFFF'}}>
                        <h4 style={{marginTop:0, ...styles.h3, fontSize: '1.1rem'}}>{r.label}</h4>
                        <p style={{fontSize:'0.85rem', color:'#475569', marginBottom: '20px'}}>{r.description}</p>
                        <button onClick={() => setOpenReportKey(r.key)} style={styles.btnPrimary}>View Report</button>
                    </div>
                ))}
                {reports.length === 0 && <p style={styles.textMuted}>No reports available.</p>}
            </div>
        )}

        {openReportKey && (
            <ReportsModal
                events={events}
                initialReportKey={openReportKey}
                onClose={() => setOpenReportKey(null)}
            />
        )}
    </div>
  );
};

export default AdminReports;
